import { Injectable } from '@angular/core';
import { Events } from '../eventService/events';
import { Storage } from '@ionic/storage-angular';
import { FacharztAPIService } from '../../providers/api-handler/api-handler';
import { AccountManagerPatient } from '../../providers/account-manager/account-manager';
import { StorageManager } from '../../providers/storage-manager/storage-manager';
import { AppSettings } from '../../app/appSettings';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../notService/notification-handler';
import { IAccountManager } from '../account-manager/IAccoung-manager';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { Platform, NavController, LoadingController, ModalController, AlertController, ToastController, IonSearchbar, IonContent } from '@ionic/angular';
import { CookieModalPage } from './modals/cookiemodal';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TagManager {
  DEBUG = AppSettings.DEBUG;
  TAG = "TagManager";
  storageMnger: StorageManager;
  cons = undefined;

  constructor(
    public mhttp: HttpClient,
    public notiService: NotificationService,
    public events: Events,
    public storage: Storage,
    public mdlCtrl: ModalController,
    public translate: TranslateService,
    private gtmService: GoogleTagManagerService
  ) {
    this.storageMnger = new StorageManager(this.storage);
    
    

  }

  

  async getConsent(): Promise<any> {
    let result;
    result = await this.storageMnger.UserConsent("get");
    if(this.DEBUG) console.log(this.TAG, "TestgetConsent1 ", result);
    if(result == undefined) {
        result = await this.openCookieModal();
        if(this.DEBUG) console.log(this.TAG, "TestgetConsent2 ", result);
        if(result == "accept") {
            return await this.saveConsent("accept");
        }else if(result == "decline") {
            return await this.saveConsent("decline");
        }else {
            return undefined;
        }
    }else {
        return result;
    }
    
  }

  async openModal() {
    let res;
    let result = await this.openCookieModal();
    if(this.DEBUG) console.log(this.TAG, "TestOpenModal ", result);
    if(result == "accept") {
        this.cons = true;
        res = await this.saveConsent("accept");
    }else if(result == "decline") {
        this.cons = false;
        res = await this.saveConsent("decline");
    }
    return res;
  }

  async saveConsent(data): Promise<any> {
    let result;
    result = await this.storageMnger.UserConsent(data);
    if(this.DEBUG) console.log(this.TAG, "TestsetConsent1 ", result);
    return result;
  }

  async track(page = "", action = "", button = "", data = "") {
    this.cons = false;
    let gtmEvent = "";
    switch (action) {
        case 'load':
            gtmEvent = "loading";
            break;
        case 'click':
            switch (button) {
                case 'openStore':
                    gtmEvent = "click";
                    break;
                case 'navigate to':
                    gtmEvent = "navigate";
                    if(data.match("http")){
                        gtmEvent = "click";
                    }
                    break;
                case 'mail to':
                    gtmEvent = "mail";
                    break;
                case 'download ICS':
                    gtmEvent = "download";
                    break;
                case 'play':
                    gtmEvent = "video";
                    break;
                case 'pause':
                    gtmEvent = "video";
                    break;
                case 'book':
                    gtmEvent = "book_appointement";
                    break;
                case 'login':
                    gtmEvent = "login";
                    break;
                case 'registration':
                    gtmEvent = "register";
                    break;
                case 'logout':
                    gtmEvent = "logout";
                    break;
                default:
                    gtmEvent = "clicking";
                    break;
            }
            break;
        
        default:
            gtmEvent = "tracking";
            break;
    }
    let gtmTag = {
        event: gtmEvent,
        pageName: "",
        action: action,
        button: button,
        data: data
    };
    if(this.cons == undefined) {
        let res = await this.getConsent();
        if(res == "accept") {
            this.cons = true;
        }else if(res == undefined) {
            this.cons = undefined;
        }else {
            this.cons = false;
        }
    }
    if(this.DEBUG) console.log(this.TAG, "TestTrackData ", gtmTag, this.cons);
    if(this.cons) {
        this.gtmService.pushTag(gtmTag);
    }
  }

  async openCookieModal() {
    let result;
    const modal = await this.mdlCtrl.create({
        component: CookieModalPage,
        cssClass: "cookie-modal",
        componentProps: {
            title: this.translate.instant('cookiebanner.title'),
            accept: this.translate.instant('cookiebanner.button_accept'),
            decline: this.translate.instant('cookiebanner.button_decline'),
            text: this.translate.instant('cookiebanner.cookie_text'),
            text2: this.translate.instant('cookiebanner.cookie_text2'),
            privacy: this.translate.instant('cookiebanner.privacy')
        }
        
    });
    modal.onDidDismiss()
        .then((data) => {
            
        });
        modal.present();
        const dis = await modal.onWillDismiss().then((data) =>{
            if(this.DEBUG) console.log(this.TAG, "TestCookieData ", data);
            if(data.data == 1 || data.data == "1") {
                result = "accept";
            }else if(data.data == 0 || data.data == "0") {
                result = "decline";
            }else {
                result = "notSet";
            }
        });
        return result;
    }


}